import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import { FAQ } from '../FAQ/faqs';
import Footer from '../Footer';





function HumanResources() {
  return (
    <>
<Features docname="Human Resources Management"/>
<Advantages docname="Human Resources Management"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default HumanResources;
